
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...dynamicRoute]]",
      function () {
        return require("private-next-pages/[[...dynamicRoute]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...dynamicRoute]]"])
      });
    }
  